import LegacyTouchWrapper from './LegacyTouchWrapper';

export default LegacyTouchWrapper;